import { apiClient } from './apiClient';

export const getCustomers = async (params = {}) => {
  const { page = 0, size = 20, search = '', status = '' } = params;
  const queryParams = new URLSearchParams();
  queryParams.append('page', page);
  queryParams.append('size', size);
  if (search) queryParams.append('search', search);
  if (status) queryParams.append('status', status);

  return await apiClient(`/admin/customers?${queryParams.toString()}`, { method: 'GET' }, true);
};

export const getCustomerDetail = async (customerId) => {
  return await apiClient(`/admin/customers/${customerId}`, { method: 'GET' }, true);
};

export const updateCustomerStatus = async (customerId, status) => {
  return await apiClient(`/admin/customers/${customerId}/status`, {
    method: 'PATCH',
    body: JSON.stringify({ status }),
  }, true);
};

export const getCustomerStatusLabel = (status) => {
  const statusLabels = {
    ACTIVE: '활성',
    INACTIVE: '휴면',
    SUSPENDED: '정지',
    BANNED: '영구정지',
  };
  return statusLabels[status] || status;
};

export const getReservationStatusLabel = (status) => {
  const statusLabels = {
    CONFIRMED: '예약',
    IN_USE: '사용',
    COMPLETED: '완료',
    CANCELLED: '취소',
    NO_SHOW: '노쇼',
  };
  return statusLabels[status] || status;
};